<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">新增</el-button>
      <!--  todo 导出  -->
      <el-button>导出</el-button>
      <el-button @click.native="handleBatchDelete">批量删除</el-button>
    </template>

    <template #search-form>
      <el-form-item label="名称">
        <el-input placeholder="名称" v-model="searchForm.name" clearable />
      </el-form-item>
      <!--      <el-form-item label="蓝牙协议代码">-->
      <!--        <el-input placeholder="蓝牙协议代码" v-model="searchForm.address" clearable/>-->
      <!--      </el-form-item>-->

      <el-form-item label="创建日期">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">搜索</el-button>
        <el-button @click="$refs.list.reset()">重置</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50" fixed/>

        <el-table-column prop="name" label="名称" fixed/>
        <el-table-column prop="specs" label="显示规格" />
        <!--        <el-table-column prop="floor" label="蓝牙协议代码"/>-->
        <el-table-column label="创建日期">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="操作" width="100">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
        <template #title>
          <h4>{{isEdit ? "编辑" : "新增"}}砝码校正</h4>
        </template>

        <el-form label-width="80px" ref="form" :model="formData" :rules="rules">
          <el-form-item label="名称" prop="name">
            <el-input placeholder="名称" v-model="formData.name" />
          </el-form-item>

          <el-form-item label="显示规格" prop="specs">
            <el-input placeholder="显示规格" v-model="formData.specs" />
          </el-form-item>

          <!--          <el-form-item label="蓝牙协议代码">-->
          <!--            <div class="flex-column10">-->
          <!--              <el-input placeholder="蓝牙协议代码" />-->
          <!--              <el-button type="primary" size="mini">保存</el-button>-->
          <!--            </div>-->
          <!--          </el-form-item>-->
          <el-form-item label="备注" prop="remark">
            <el-input placeholder="备注" v-model="formData.remark" type="textarea" :rows="4" />
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleConfirmByForm">确定</el-button>
          <el-button @click="resetForm">重置</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import {resetEmpty} from "@/utils/common";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "WeighCalList",
  components: {AnkhList, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,

      formData: {
        name: "",
        remark: "",
        protocolCode: null,
        specs: ""
      },
      rules: {
        name: {required: true, message: "请输入名称", trigger: "blur"},
        specs: {required: true, message: "请输入显示规格", trigger: "blur"},
      },
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 确定
    handleConfirmByForm() {
      this.$refs.form.validate(async (valid) =>{
        if(!valid) return;
        try {
          const action = this.$api.weightCorrectSort[this.isEdit ? 'update' : 'add'];
          let params = {...this.formData};
          if(this.isEdit) {
            params = Object.assign(this.currentRow, this.formData);
            delete params.createTime;
            delete params.updateTime;
          }
          await request(action, params);
          this.$message.success("操作成功");
          this.showDialog = false;
          this.$refs.list.handleRequest();
        } catch (e) {
          console.log(e);
        }
      })
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        for (const key in this.formData) {
          this.formData[key] = row[key];
        }
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.weightCorrectSort.delete, {code: row.code});
        this.$message.success("操作成功")
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '未选择记录'
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.weightCorrectSort.batchDelete,
            codes,
            {isJson: true},
            {message: "您现在正在进行批量删除操作, 是否继续?"}
        );
        this.$message.success("操作成功");
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.weightCorrectSort.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 500px;
  border-radius: 10px;
}
</style>
